import {useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import {readTicketQueueState, writeTicketQueueState} from './ticketQueueState';

export const useTicketQueueState = () => {
  const [params, setParams] = useSearchParams();
  const state = readTicketQueueState(params.toString());
  // Keep these references stable when only pagination or view mode changes.
  const filtersKey = params.get('filters');
  const usersKey = params.get('users');
  const filters = useMemo(
    () =>
      readTicketQueueState(
        new URLSearchParams({filters: filtersKey || ''}).toString(),
      ).filters,
    [filtersKey],
  );
  const selectedUsers = useMemo(
    () =>
      readTicketQueueState(
        new URLSearchParams({users: usersKey || ''}).toString(),
      ).selectedUsers,
    [usersKey],
  );
  const update = patch =>
    setParams(
      current => {
        const previous = readTicketQueueState(current.toString());
        return writeTicketQueueState({
          ...previous,
          ...(typeof patch === 'function' ? patch(previous) : patch),
        });
      },
      {replace: true},
    );
  return [{...state, filters, selectedUsers}, update];
};
